/* eslint-disable react/jsx-filename-extension */
import 'raf/polyfill';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { createHashHistory } from 'history';

import registerServiceWorker from './registerServiceWorker';
import configureStore from './configureStore';

import Main from './main';
import './styles';

const history = createHashHistory();

const initialState = window.initialReduxState;
const store = configureStore(history, initialState);

ReactDOM.render(<Main store={store} history={history} />, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js